<app-menu headerCSS="bg-dark" displaySignIn="false"></app-menu>
<div class="status">
    <p *ngIf="activationStatus == activationStatuses.Activating">
        Activating your account, Please wait...
    </p>
    <p *ngIf="activationStatus == activationStatuses.Activated">
        Your email has been verifed and your account has been activated. 
        <br>
        Please click 
        <a href="" [routerLink]="['../signin']">
            here
        </a>
         to signin.
    </p>
    <p *ngIf="activationStatus == activationStatuses.Failure">
        Error when trying to activate your account.
    </p>
</div>
<div class="error-msg">
    <p *ngIf="activationStatus == activationStatuses.Failure">
        {{error}}
    </p>
</div>

